import { combineReducers } from 'redux';
import types from './types';

export const challenge = (state = {
  item: null,
  activity: null,
  leaderboard: null,
  awards: null,
  participants: null,
  activities: null,
  loading: false,
  error: null,
}, action) => {
  switch (action.type) {
    case types.GET_REQUEST:
    case types.SAVE_REQUEST:
    case types.GET_ACTIVITY_REQUEST:
    case types.GET_PARTICIPANTS_REQUEST:
    case types.GET_LEADERBOARD_REQUEST:
    case types.GET_AWARDS_REQUEST:
    case types.GET_ACTIVITIES_REQUEST:
    case types.CHALLENGES_JOIN_REQUEST:
    case types.CHALLENGES_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_FAILURE:
    case types.SAVE_FAILURE:
    case types.CHALLENGES_JOIN_FAILURE:
    case types.CHALLENGES_LEAVE_FAILURE:
    case types.GET_PARTICIPANTS_FAILURE:
    case types.GET_LEADERBOARD_FAILURE:
    case types.GET_ACTIVITY_FAILURE:
    case types.GET_AWARDS_FAILURE:
    case types.GET_ACTIVITIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.SAVE_SUCCESS:
    case types.CHALLENGES_JOIN_SUCCESS:
    case types.CHALLENGES_LEAVE_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_LEADERBOARD_SUCCESS:
      return {
        ...state,
        leaderboard: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_AWARDS_SUCCESS:
      return {
        ...state,
        awards: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        participants: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.CLEAR_CURRENT:
      return {
        ...state,
        item: null,
        activity: null,
        leaderboard: null,
        awards: null,
        participants: null,
        activities: null,
      }
    default:
      return state
  }
}


export const challenges = (state = {
  loading: false,
  items: [],
  error: null,
}, action) => {
  //console.log('::::::REDUCER::CHALLENGES::challenges::', action);
  switch (action.type) {
    case types.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data,
        query: action.payload.query
      };
    case types.GETALL_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.id
            ? { ...item, deleting: true }
            : item
        )
      };
    case types.DELETE_SUCCESS:
      // remove deleted item from state
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.id)
      };
    case types.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to item 
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === action.id) {
            // make copy of product without 'deleting:true' property
            const { deleting, ...itemCopy } = item;
            // return copy of product with 'deleteError:[error]' property
            return { ...itemCopy, deleteError: action.error };
          }

          return item;
        })
      };
  
    default:
      return state
  }
}


export default combineReducers({
  current: challenge,
  list: challenges
});

